import { productService } from '@/services/productService';
import { customerService } from '@/services/customerService';
import { supplierService } from '@/services/supplierService';
import { REQUIRED_CATALOG_PRODUCTS } from '@/lib/catalogTemplates';
import { storage } from '@/lib/storage';

const wheelProducts = [
  {
    sku: 'WHEEL-001',
    barcode: '1234567890900',
    name: 'BBS CH-R Alloy Wheel 17"',
    name_ar: 'جنوط بي بي اس 17 بوصة',
    category: 'wheels' as const,
    description: '17x7.5 ET45 5x112 Silver Finish',
    cost_price: 180.00,
    selling_price: 280.00,
    current_stock: 8,
    min_stock_level: 4,
    location: 'Aisle W-1',
    tax_rate: 5,
    is_active: true,
  },
  {
    sku: 'WHEEL-002',
    barcode: '1234567890901',
    name: 'OZ Racing Superturismo 18"',
    name_ar: 'جنوط او زد سوبرتوريزمو 18 بوصة',
    category: 'wheels' as const,
    description: '18x8 ET48 5x120 Matt Black',
    cost_price: 250.00,
    selling_price: 380.00,
    current_stock: 6,
    min_stock_level: 3,
    location: 'Aisle W-1',
    tax_rate: 5,
    is_active: true,
  },
  {
    sku: 'WHEEL-003',
    barcode: '1234567890902',
    name: 'Enkei RPF1 19"',
    name_ar: 'جنوط انكي ار بي اف 1 - 19 بوصة',
    category: 'wheels' as const,
    description: '19x9.5 ET38 5x114.3 Gloss Black',
    cost_price: 280.00,
    selling_price: 420.00,
    current_stock: 4,
    min_stock_level: 2,
    location: 'Aisle W-2',
    tax_rate: 5,
    is_active: true,
  },
  {
    sku: 'WHEEL-004',
    barcode: '1234567890903',
    name: 'Vossen CV3-R 20"',
    name_ar: 'جنوط فوسن سي في 3 ار - 20 بوصة',
    category: 'wheels' as const,
    description: '20x10 ET25 5x112 Graphite Metallic',
    cost_price: 350.00,
    selling_price: 520.00,
    current_stock: 3,
    min_stock_level: 2,
    location: 'Aisle W-2',
    tax_rate: 5,
    is_active: true,
  },
  {
    sku: 'WHEEL-005',
    barcode: '1234567890904',
    name: 'Borbet A 16"',
    name_ar: 'جنوط بوربت اي - 16 بوصة',
    category: 'wheels' as const,
    description: '16x7 ET35 5x100 Silver',
    cost_price: 120.00,
    selling_price: 190.00,
    current_stock: 12,
    min_stock_level: 6,
    location: 'Aisle W-3',
    tax_rate: 5,
    is_active: true,
  },
  {
    sku: 'WHEEL-006',
    barcode: '1234567890905',
    name: 'Rotiform RSE 18"',
    name_ar: 'جنوط روتيفورم ار اس اي - 18 بوصة',
    category: 'wheels' as const,
    description: '18x8.5 ET45 5x112 Gunmetal',
    cost_price: 220.00,
    selling_price: 340.00,
    current_stock: 5,
    min_stock_level: 3,
    location: 'Aisle W-3',
    tax_rate: 5,
    is_active: true,
  },
  {
    sku: 'WHEEL-007',
    barcode: '1234567890906',
    name: 'Work Emotion CR Kiwami 17"',
    name_ar: 'جنوط وورك ايموشن - 17 بوصة',
    category: 'wheels' as const,
    description: '17x9 ET38 5x114.3 Bronze',
    cost_price: 200.00,
    selling_price: 310.00,
    current_stock: 7,
    min_stock_level: 4,
    location: 'Aisle W-4',
    tax_rate: 5,
    is_active: true,
  },
  {
    sku: 'WHEEL-008',
    barcode: '1234567890907',
    name: 'Steel Wheel 15"',
    name_ar: 'جنوط حديد 15 بوصة',
    category: 'wheels' as const,
    description: '15x6 ET40 5x108 Black Steel',
    cost_price: 45.00,
    selling_price: 75.00,
    current_stock: 20,
    min_stock_level: 10,
    location: 'Section W-5',
    tax_rate: 5,
    is_active: true,
  },
  {
    sku: 'WHEEL-009',
    barcode: '1234567890908',
    name: 'Steel Wheel 16"',
    name_ar: 'جنوط حديد 16 بوصة',
    category: 'wheels' as const,
    description: '16x6.5 ET50 4x100 Silver Steel',
    cost_price: 50.00,
    selling_price: 80.00,
    current_stock: 18,
    min_stock_level: 8,
    location: 'Section W-5',
    tax_rate: 5,
    is_active: true,
  },
  {
    sku: 'WHEEL-010',
    barcode: '1234567890909',
    name: 'Rays TE37 18"',
    name_ar: 'جنوط رايز تي اي 37 - 18 بوصة',
    category: 'wheels' as const,
    description: '18x9.5 ET22 5x114.3 Bronze',
    cost_price: 320.00,
    selling_price: 490.00,
    current_stock: 4,
    min_stock_level: 2,
    location: 'Aisle W-4',
    tax_rate: 5,
    is_active: true,
  },
];

const batteryProducts = [
  {
    sku: 'BATT-001',
    barcode: '1234567890500',
    name: 'Car Battery 12V 70Ah AGM',
    name_ar: 'بطارية سيارة 12 فولت 70 أمبير',
    category: 'batteries' as const,
    description: 'AGM Technology Battery',
    cost_price: 85.00,
    selling_price: 145.00,
    current_stock: 8,
    min_stock_level: 4,
    location: 'Section D-1',
    tax_rate: 5,
    is_active: true,
  },
  {
    sku: 'BATT-002',
    barcode: '1234567890505',
    name: 'Car Battery 12V 60Ah Maintenance-Free',
    name_ar: 'بطارية سيارة 12 فولت 60 أمبير',
    category: 'batteries' as const,
    description: 'Maintenance-free battery for compact cars',
    cost_price: 68.00,
    selling_price: 118.00,
    current_stock: 10,
    min_stock_level: 5,
    location: 'Section D-1',
    tax_rate: 5,
    is_active: true,
  },
  {
    sku: 'BATT-003',
    barcode: '1234567890506',
    name: 'Car Battery 12V 90Ah Heavy Duty',
    name_ar: 'بطارية سيارة 12 فولت 90 أمبير',
    category: 'batteries' as const,
    description: 'Heavy duty battery for SUVs and vans',
    cost_price: 110.00,
    selling_price: 180.00,
    current_stock: 5,
    min_stock_level: 3,
    location: 'Section D-2',
    tax_rate: 5,
    is_active: true,
  },
];

// Browser-storage keys the sample seed writes to (directly or via productService.create).
const SAMPLE_DATA_STORAGE_KEYS = [
  'products',
  'product_batches',
  'price_history',
  'inventory_movements',
  'customers',
  'suppliers',
];

/**
 * Live (Supabase) mode: remove the demo catalog that earlier builds seeded into
 * browser storage on every start, so it can't surface in any screen that still
 * reads local storage.
 */
export const clearSampleData = () => {
  SAMPLE_DATA_STORAGE_KEYS.forEach((key) => storage.remove(key));
};

export const seedSampleData = () => {
  const existingProducts = productService.getAll();
  const existingKeys = new Set(
    existingProducts.flatMap((product) => [
      `sku:${product.sku.trim().toLowerCase()}`,
      `name:${product.name.trim().toLowerCase()}`,
    ]),
  );
  REQUIRED_CATALOG_PRODUCTS.forEach((product) => {
    const skuKey = `sku:${product.sku.trim().toLowerCase()}`;
    const nameKey = `name:${product.name.trim().toLowerCase()}`;
    if (!existingKeys.has(skuKey) && !existingKeys.has(nameKey)) {
      productService.create(product);
      existingKeys.add(skuKey);
      existingKeys.add(nameKey);
    }
  });
  
  // Check if wheels category exists
  const refreshedProducts = productService.getAll();
  const hasWheels = refreshedProducts.some(p => p.category === 'wheels');
  const hasBatteries = refreshedProducts.some(p => p.category === 'batteries');
  
  // If existing local sample data is missing Sprint 0 categories, add them only.
  if (refreshedProducts.length > REQUIRED_CATALOG_PRODUCTS.length) {
    if (!hasWheels) {
      wheelProducts.forEach(wheel => productService.create(wheel));
      console.log('Added 10 wheel products to existing inventory');
    }
    if (!hasBatteries) {
      batteryProducts.forEach(battery => productService.create(battery));
      console.log('Added battery products to existing inventory');
    }
    return;
  }
  
  const sampleProducts = [
    // WHEELS - 10 varieties (Alloy & Steel)
    ...wheelProducts,

    // BATTERIES - Core garage product line
    ...batteryProducts,

    // TIRES - Various sizes, brands, and seasons
    {
      sku: 'TIRE-001',
      barcode: '1234567890123',
      name: 'Michelin Pilot Sport 4',
      name_ar: 'ميشلان بايلوت سبورت 4',
      category: 'tires' as const,
      description: '225/45R17 Performance Tire',
      cost_price: 120.00,
      selling_price: 180.00,
      current_stock: 12,
      min_stock_level: 5,
      location: 'Aisle A-1',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'TIRE-002',
      barcode: '1234567890126',
      name: 'Bridgestone Turanza T005',
      name_ar: 'بريدجستون تورانزا',
      category: 'tires' as const,
      description: '205/55R16 All Season Tire',
      cost_price: 95.00,
      selling_price: 150.00,
      current_stock: 8,
      min_stock_level: 5,
      location: 'Aisle A-1',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'TIRE-003',
      barcode: '1234567890200',
      name: 'Goodyear Eagle F1 Asymmetric',
      name_ar: 'جوديير ايجل اف1',
      category: 'tires' as const,
      description: '245/40R18 97Y Run-Flat Performance',
      cost_price: 145.00,
      selling_price: 220.00,
      current_stock: 6,
      min_stock_level: 4,
      location: 'Aisle A-2',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'TIRE-004',
      barcode: '1234567890201',
      name: 'Pirelli Winter Sottozero 3',
      name_ar: 'بيريللي وينتر سوتوزيرو',
      category: 'tires' as const,
      description: '225/50R17 Winter Tire',
      cost_price: 110.00,
      selling_price: 175.00,
      current_stock: 10,
      min_stock_level: 6,
      location: 'Aisle A-2',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'TIRE-005',
      barcode: '1234567890202',
      name: 'Continental PremiumContact 6',
      name_ar: 'كونتيننتال بريميوم كونتاكت',
      category: 'tires' as const,
      description: '195/65R15 Eco Tire',
      cost_price: 75.00,
      selling_price: 115.00,
      current_stock: 15,
      min_stock_level: 8,
      location: 'Aisle A-3',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'TIRE-006',
      barcode: '1234567890203',
      name: 'Yokohama BluEarth AE50',
      name_ar: 'يوكوهاما بلو ايرث',
      category: 'tires' as const,
      description: '215/60R16 All-Season',
      cost_price: 85.00,
      selling_price: 135.00,
      current_stock: 2,
      min_stock_level: 6,
      location: 'Aisle A-3',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'TIRE-007',
      barcode: '1234567890204',
      name: 'Dunlop Sport Maxx RT2',
      name_ar: 'دنلوب سبورت ماكس',
      category: 'tires' as const,
      description: '255/35R19 Ultra High Performance',
      cost_price: 165.00,
      selling_price: 250.00,
      current_stock: 4,
      min_stock_level: 3,
      location: 'Aisle A-4',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'TIRE-008',
      barcode: '1234567890205',
      name: 'Hankook Ventus V12 evo2',
      name_ar: 'هانكوك فينتوس',
      category: 'tires' as const,
      description: '205/55R16 Sport Tire',
      cost_price: 70.00,
      selling_price: 110.00,
      current_stock: 18,
      min_stock_level: 10,
      location: 'Aisle A-4',
      tax_rate: 5,
      is_active: true,
    },

    // OILS & LUBRICANTS - Various weights and types
    {
      sku: 'OIL-001',
      barcode: '1234567890124',
      name: 'Mobil 1 Full Synthetic 5W-30',
      name_ar: 'موبيل 1 صناعي كامل',
      category: 'lubes_fluids' as const,
      description: '5 Quart Jug',
      cost_price: 25.00,
      selling_price: 45.00,
      current_stock: 24,
      min_stock_level: 10,
      location: 'Bay B-1',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'OIL-002',
      barcode: '1234567890127',
      name: 'Castrol EDGE 0W-40',
      name_ar: 'كاسترول ايدج',
      category: 'lubes_fluids' as const,
      description: '4 Liter Container',
      cost_price: 30.00,
      selling_price: 55.00,
      current_stock: 18,
      min_stock_level: 10,
      location: 'Bay B-1',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'OIL-003',
      barcode: '1234567890300',
      name: 'Shell Helix Ultra 5W-40',
      name_ar: 'شل هيليكس الترا',
      category: 'lubes_fluids' as const,
      description: '4L Fully Synthetic',
      cost_price: 28.00,
      selling_price: 52.00,
      current_stock: 20,
      min_stock_level: 12,
      location: 'Bay B-2',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'OIL-004',
      barcode: '1234567890301',
      name: 'Total Quartz 9000 5W-30',
      name_ar: 'توتال كوارتز',
      category: 'lubes_fluids' as const,
      description: '5L Synthetic',
      cost_price: 26.00,
      selling_price: 48.00,
      current_stock: 3,
      min_stock_level: 10,
      location: 'Bay B-2',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'OIL-005',
      barcode: '1234567890302',
      name: 'Valvoline MaxLife 10W-40',
      name_ar: 'فالفولين ماكس لايف',
      category: 'lubes_fluids' as const,
      description: '5L High Mileage',
      cost_price: 22.00,
      selling_price: 40.00,
      current_stock: 16,
      min_stock_level: 10,
      location: 'Bay B-3',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'OIL-006',
      barcode: '1234567890303',
      name: 'Liqui Moly Synthoil 5W-50',
      name_ar: 'ليكوي مولي سينثويل',
      category: 'lubes_fluids' as const,
      description: '4L Premium Synthetic',
      cost_price: 35.00,
      selling_price: 65.00,
      current_stock: 12,
      min_stock_level: 8,
      location: 'Bay B-3',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'OIL-007',
      barcode: '1234567890304',
      name: 'Motul 8100 X-cess 5W-40',
      name_ar: 'موتول 8100',
      category: 'lubes_fluids' as const,
      description: '5L Synthetic',
      cost_price: 32.00,
      selling_price: 58.00,
      current_stock: 14,
      min_stock_level: 10,
      location: 'Bay B-4',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'OIL-008',
      barcode: '1234567890305',
      name: 'Petronas Syntium 0W-20',
      name_ar: 'بتروناس سينتيوم',
      category: 'lubes_fluids' as const,
      description: '4L Full Synthetic',
      cost_price: 29.00,
      selling_price: 53.00,
      current_stock: 10,
      min_stock_level: 8,
      location: 'Bay B-4',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'OIL-009',
      barcode: '1234567890306',
      name: 'ATF Transmission Fluid Dexron VI',
      name_ar: 'زيت ناقل الحركة',
      category: 'lubes_fluids' as const,
      description: '4L Automatic Transmission',
      cost_price: 18.00,
      selling_price: 32.00,
      current_stock: 22,
      min_stock_level: 12,
      location: 'Bay B-5',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'OIL-010',
      barcode: '1234567890307',
      name: 'Hydraulic Brake Fluid DOT 4',
      name_ar: 'زيت فرامل',
      category: 'lubes_fluids' as const,
      description: '1L High Performance',
      cost_price: 8.00,
      selling_price: 15.00,
      current_stock: 30,
      min_stock_level: 15,
      location: 'Bay B-5',
      tax_rate: 5,
      is_active: true,
    },

    // FILTERS - Air, oil, fuel, cabin
    {
      sku: 'FILTER-001',
      barcode: '1234567890125',
      name: 'K&N Air Filter',
      name_ar: 'فلتر هواء كيه آند ان',
      category: 'filters' as const,
      description: 'High Performance Air Filter',
      cost_price: 35.00,
      selling_price: 65.00,
      current_stock: 3,
      min_stock_level: 5,
      location: 'Shelf C-1',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'FILTER-002',
      barcode: '1234567890128',
      name: 'Mann Oil Filter',
      name_ar: 'فلتر زيت مان',
      category: 'filters' as const,
      description: 'Premium Oil Filter',
      cost_price: 12.00,
      selling_price: 25.00,
      current_stock: 2,
      min_stock_level: 8,
      location: 'Shelf C-2',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'FILTER-003',
      barcode: '1234567890400',
      name: 'Bosch Air Filter Premium',
      name_ar: 'فلتر هواء بوش',
      category: 'filters' as const,
      description: 'Premium Engine Air Filter',
      cost_price: 18.00,
      selling_price: 32.00,
      current_stock: 25,
      min_stock_level: 10,
      location: 'Shelf C-1',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'FILTER-004',
      barcode: '1234567890401',
      name: 'Mahle Oil Filter OC 90',
      name_ar: 'فلتر زيت ماهلي',
      category: 'filters' as const,
      description: 'OEM Quality Oil Filter',
      cost_price: 10.00,
      selling_price: 20.00,
      current_stock: 40,
      min_stock_level: 20,
      location: 'Shelf C-2',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'FILTER-005',
      barcode: '1234567890402',
      name: 'WIX Fuel Filter 33533',
      name_ar: 'فلتر وقود ويكس',
      category: 'filters' as const,
      description: 'High-Efficiency Diesel Filter',
      cost_price: 15.00,
      selling_price: 28.00,
      current_stock: 18,
      min_stock_level: 10,
      location: 'Shelf C-3',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'FILTER-006',
      barcode: '1234567890403',
      name: 'Fram Cabin Air Filter CF10285',
      name_ar: 'فلتر مكيف فرام',
      category: 'filters' as const,
      description: 'Activated Carbon Cabin Filter',
      cost_price: 14.00,
      selling_price: 26.00,
      current_stock: 22,
      min_stock_level: 12,
      location: 'Shelf C-1',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'FILTER-007',
      barcode: '1234567890404',
      name: 'UFI Oil Filter 23.443.00',
      name_ar: 'فلتر زيت يو اف آي',
      category: 'filters' as const,
      description: 'Professional Grade',
      cost_price: 11.00,
      selling_price: 22.00,
      current_stock: 35,
      min_stock_level: 15,
      location: 'Shelf C-2',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'FILTER-008',
      barcode: '1234567890405',
      name: 'Champion Air Filter CAF100872P',
      name_ar: 'فلتر هواء تشامبيون',
      category: 'filters' as const,
      description: 'Performance Air Filter',
      cost_price: 16.00,
      selling_price: 30.00,
      current_stock: 4,
      min_stock_level: 10,
      location: 'Shelf C-1',
      tax_rate: 5,
      is_active: true,
    },

    // ACCESSORIES - Tools and equipment
    {
      sku: 'ACC-001',
      barcode: '1234567890129',
      name: 'Tire Pressure Gauge Digital',
      name_ar: 'مقياس ضغط الإطارات الرقمي',
      category: 'accessories' as const,
      description: 'Digital Tire Pressure Gauge',
      cost_price: 8.00,
      selling_price: 18.00,
      current_stock: 15,
      min_stock_level: 5,
      location: 'Shelf E-1',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'ACC-003',
      barcode: '1234567890501',
      name: 'Brake Pad Set Front Ceramic',
      name_ar: 'طقم فحمات فرامل أمامية',
      category: 'accessories' as const,
      description: 'Ceramic Compound Brake Pads',
      cost_price: 45.00,
      selling_price: 80.00,
      current_stock: 12,
      min_stock_level: 6,
      location: 'Section D-2',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'ACC-004',
      barcode: '1234567890502',
      name: 'Windshield Wiper Blades 24" Premium',
      name_ar: 'ماسحات زجاج أمامي',
      category: 'accessories' as const,
      description: '24" Pair Premium Quality',
      cost_price: 12.00,
      selling_price: 25.00,
      current_stock: 28,
      min_stock_level: 15,
      location: 'Shelf E-1',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'ACC-005',
      barcode: '1234567890503',
      name: 'LED Headlight Bulbs H7 6000K',
      name_ar: 'لمبات ليد للإضاءة الأمامية',
      category: 'accessories' as const,
      description: '6000K White Pair',
      cost_price: 22.00,
      selling_price: 42.00,
      current_stock: 16,
      min_stock_level: 10,
      location: 'Shelf E-2',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'ACC-006',
      barcode: '1234567890504',
      name: 'Spark Plug Set Iridium 4-Pack',
      name_ar: 'طقم شمعات إشعال',
      category: 'accessories' as const,
      description: 'Iridium Long-Life',
      cost_price: 18.00,
      selling_price: 35.00,
      current_stock: 20,
      min_stock_level: 10,
      location: 'Shelf E-3',
      tax_rate: 5,
      is_active: true,
    },

    // OTHER - Car care and chemicals
    {
      sku: 'OTH-001',
      barcode: '1234567890600',
      name: 'Car Wash Shampoo pH Neutral',
      name_ar: 'شامبو غسيل السيارات',
      category: 'other' as const,
      description: 'pH Neutral 5L Concentrate',
      cost_price: 10.00,
      selling_price: 20.00,
      current_stock: 35,
      min_stock_level: 15,
      location: 'Section F-1',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'OTH-002',
      barcode: '1234567890601',
      name: 'Engine Degreaser Industrial',
      name_ar: 'منظف المحرك الصناعي',
      category: 'other' as const,
      description: 'Industrial Strength 1L',
      cost_price: 6.00,
      selling_price: 12.00,
      current_stock: 40,
      min_stock_level: 20,
      location: 'Section F-1',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'OTH-003',
      barcode: '1234567890602',
      name: 'Coolant Antifreeze Concentrated',
      name_ar: 'سائل تبريد مركز',
      category: 'other' as const,
      description: 'Concentrated 5L',
      cost_price: 15.00,
      selling_price: 28.00,
      current_stock: 25,
      min_stock_level: 12,
      location: 'Section F-2',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'OTH-004',
      barcode: '1234567890603',
      name: 'Tire Shine Spray Long-Lasting',
      name_ar: 'سبراي تلميع الإطارات',
      category: 'other' as const,
      description: 'Long-Lasting 500ml',
      cost_price: 5.00,
      selling_price: 11.00,
      current_stock: 3,
      min_stock_level: 10,
      location: 'Section F-3',
      tax_rate: 5,
      is_active: true,
    },
    {
      sku: 'OTH-005',
      barcode: '1234567890604',
      name: 'Glass Cleaner Streak-Free',
      name_ar: 'منظف زجاج خالي من الخطوط',
      category: 'other' as const,
      description: 'Streak-Free 750ml',
      cost_price: 4.00,
      selling_price: 9.00,
      current_stock: 45,
      min_stock_level: 20,
      location: 'Section F-3',
      tax_rate: 5,
      is_active: true,
    },
  ];

  const sampleCustomers = [
    {
      name: 'Rami Haddad',
      phone: '+961 3 123 456',
      email: 'rami@example.com',
      address: 'Simkanieh, Chouf',
    },
    {
      name: 'Maya Khoury',
      phone: '+961 70 456 789',
      email: 'maya@example.com',
      address: 'Beirut, Lebanon',
    },
    {
      name: 'Karim Nassar',
      phone: '+961 76 555 210',
      email: 'karim@example.com',
      address: 'Aley, Mount Lebanon',
    },
  ];

  const sampleSuppliers = [
    {
      name: 'Chouf Tires & Wheels Supply',
      contact_person: 'Nabil Haddad',
      phone: '+961 5 550 123',
      email: 'sales@chouftires.example',
      address: 'Simkanieh, Chouf',
      notes: 'Main supplier for tires and جنوط',
      is_active: true,
    },
    {
      name: 'Beirut Oils & Lubricants',
      contact_person: 'Fadi Karam',
      phone: '+961 1 660 240',
      email: 'orders@beirutoils.example',
      address: 'Dora, Beirut',
      notes: 'Preferred supplier for all oil and lubricant products',
      is_active: true,
    },
    {
      name: 'Mount Lebanon Battery House',
      contact_person: 'Georges Saad',
      phone: '+961 3 880 420',
      email: 'batteries@mlbattery.example',
      address: 'Mkalles, Mount Lebanon',
      notes: 'Battery supplier for cars, SUVs, and vans',
      is_active: true,
    },
    {
      name: 'Simkanieh Filters & Garage Parts',
      contact_person: 'Samir Daher',
      phone: '+961 81 222 740',
      email: 'parts@simkaniehgarage.example',
      address: 'Simkanieh, Chouf',
      notes: 'Filters, small accessories, and garage consumables',
      is_active: true,
    },
  ];

  // First create suppliers
  const suppliers = sampleSuppliers.map(s => supplierService.create(s));
  
  // Map supplier names to IDs for easy reference
  const supplierMap: Record<string, string> = {};
  suppliers.forEach(s => {
    supplierMap[s.name] = s.id;
  });

  // Update products with preferred suppliers
  const productsWithSuppliers = sampleProducts.map(p => {
    let preferred_supplier_id: string | undefined;
    
    // Assign suppliers based on category
    if (p.category === 'tires' || p.category === 'wheels') {
      preferred_supplier_id = supplierMap['Chouf Tires & Wheels Supply'];
    } else if (p.category === 'batteries') {
      preferred_supplier_id = supplierMap['Mount Lebanon Battery House'];
    } else if (p.category === 'lubes_fluids') {
      preferred_supplier_id = supplierMap['Beirut Oils & Lubricants'];
    } else if (p.category === 'filters' || p.category === 'accessories') {
      preferred_supplier_id = supplierMap['Simkanieh Filters & Garage Parts'];
    }
    
    return {
      ...p,
      preferred_supplier_id,
    };
  });

  productsWithSuppliers.forEach(p => productService.create(p));

  sampleCustomers.forEach(c => customerService.create(c));
};
